import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ConfigContext from '../../../contexts/ConfigContext';

import ResponsiveImg from '../../shared/ResponsiveImg';

import styles from './CateringCta.module.postcss';
import CDN_BASE from '../../../utils/cdn';

// Closing catering call-to-action. The bullets are the bible's trust lines
// (§6) and the button names the destination: the catering request wizard.
function CateringCta({ title }) {
  const { city_name } = useContext(ConfigContext);
  const citySlug = city_name.toLowerCase();

  return (
    <div className={styles.CateringCta}>
      {/*
        Previously passed `widths={[200, 400, 800]}`, which made
        `ResponsiveImg` emit `src="book-catering-200w.webp"` as the static
        fallback. That variant has never existed in S3 (both Austin and
        Seattle buckets return 403) — discovered during the Austin PSI audit.
        Using 400/600/800 keeps the srcset honest and gives a working
        `defaultSrc` at 400w.
      */}
      <ResponsiveImg
        className={styles.CateringCta_img}
        src={`${CDN_BASE}/photos/${citySlug}-book-food-truck-catering.webp`}
        widths={[400, 600, 800, 1000]}
        // Mobile: full width minus Section padding (24px each side).
        // Desktop (>900px): image is flex:33% of the Section container.
        sizes='(max-width: 900px) calc(100vw - 48px), 33vw'
        alt='Food truck catering at an event'
        loading='lazy'
        width={400}
        height={300}
      />
      <div className={styles.CateringCta_content}>
        <h3 className='u-mb0 u-phosphate'>{ title || 'Planning an event?'}</h3>
        <ul>
          <li>Requesting quotes is free.</li>
          <li>Compare menus and pricing before you book.</li>
          <li>Message trucks directly.</li>
        </ul>
        <Link to='/catering/requests/new' className='Button Button--wide Button--mobile-w100'>
          Get catering quotes
        </Link>
      </div>
    </div>
  );
}

CateringCta.propTypes = {
  title: PropTypes.node,
};

export default CateringCta;
